import { render, staticRenderFns } from "./_Option.vue?vue&type=template&id=75051640&scoped=true&"
import script from "./_Option.vue?vue&type=script&lang=js&"
export * from "./_Option.vue?vue&type=script&lang=js&"
import style0 from "./_Option.vue?vue&type=style&index=0&id=75051640&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75051640",
  null
  
)

export default component.exports